import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import MasterPage from "../components/MasterPage";

const FAQ = React.lazy(() => import("../components/lpConteudos/FAQ"));

import AOS from "aos";
import "aos/dist/aos.css";
import SEO from "../components/home/SEO";
import NewHeader from "../components/new-home/NewHeader";
import Lojinha from "../components/new-home/Lojinha";
import LojinhaMobile from "../components/new-home/LojinhaMobile";
import NewHighlights from "../components/new-home/NewHighlights";
import Beneficios from "../components/new-home/Beneficios";
import Vantagens from "../components/new-home/Vantagens";

import HomeVariables from "../data/home/homeVariables";
import GlobalVariables from "../data/globalVariables";

import useQueryLpData from "../hooks/useQueryLpData";
import useQueryHtmlData from "../hooks/useQueryHtmlData";

import PlanosJSON from "../data/planos-nova-pv.json";
import ContentJSON from "../data/conteudos-oferecidos.json";
import SinglesJSON from "../data/lojinha-nova-pv.json";

import { useMobile } from "../hooks/useMobile";
import PlansMobile from "../components/updated/PlansMobile";
import PlansTabs from "../components/updated/PlansTabs";

export default function Home() {
  let content = null;
  const [planIndex, setPlanIndex] = useState(0);
  const [planOpenIndex, setPlanOpenIndex] = useState(null);

  const { isMobile } = useMobile(1270);

  const location = useLocation();

  useEffect(() => {
    AOS.init();
  }, []);

  const contentResponse = useQueryLpData("CONTEUDOS", "");
  if (contentResponse.data) {
    content = contentResponse.data;
  } else {
    content = ContentJSON;
  }

  const responseHTML = useQueryHtmlData(
    "HOME FAQ",
    "https://jsuol.com/p/pp/uol-play/publicador/faqs/faq-new-home.html"
  );

  const scrollToPlans = () => {
    const idMap = {
      "#futebol": "uolplay_futebol",
      "#pipoca": "uolplay_pipoca",
    };

    const elementId =
      isMobile && idMap[location.hash] ? idMap[location.hash] : "planos";

    const element = document.getElementById(elementId);
    const offset = isMobile ? 60 : 80;

    if (element) {
      const position =
        element.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top: position,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const hash = location.hash;

    if (hash === "#futebol") {
      setPlanIndex(1);
      setPlanOpenIndex(1)
    } else if (hash === "#pipoca") {
      setPlanIndex(2);
      setPlanOpenIndex(2)
    } else {
      setPlanIndex(0);
      setPlanOpenIndex(null)
    }

    if (hash === "#futebol" || hash === "#pipoca") {
      const timer = setTimeout(() => {
        scrollToPlans();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [location.hash, isMobile]);

  return (
    <MasterPage namePage="home">
      {HomeVariables?.seo && <SEO content={HomeVariables?.seo} />}

      <NewHeader />

      {isMobile ? (
        <PlansMobile
          planIndex={planIndex}
          planOpenIndex={planOpenIndex}
          content={PlanosJSON?.benefits}
          planos={PlanosJSON?.plans}
          title="Temos um combo especial para você curtir um universo de conteúdos"
        />
      ) : (
        <PlansTabs
          planIndex={planIndex}
          content={PlanosJSON?.benefits}
          planos={PlanosJSON?.plans}
          title="Temos um combo especial para você curtir um universo de conteúdos"
          hasSubtitle
          hasReceba40
        />
      )}

      {isMobile ? (
        <LojinhaMobile channels={SinglesJSON?.channels} />
      ) : (
        <Lojinha channels={SinglesJSON?.channels} />
      )}

      <NewHighlights />

      <Vantagens />

      <Beneficios />

      {GlobalVariables?.faq && (
        <React.Suspense>
          {/* <Duvidas content={HomeVariables?.faq} /> */}
          <FAQ metaData={GlobalVariables?.faq} htmlData={responseHTML?.data} />
        </React.Suspense>
      )}
    </MasterPage>
  );
}
